<template>
    <div>
        <div class="shop-info">
            <van-image class="logo" :src="resUrl + shop.logo" />
            <div class="shop-title">{{shop.name}}</div>
        </div>
        <cell-group>
            <field v-if="type == 'reg'"
                v-model="mobile"
                placeholder="手机号"
            />
            <field v-if="type == 'rep'"
                v-model="oldmobile"
                placeholder="原手机号"
            />
            <field v-if="type == 'rep'"
                v-model="mobile"
                placeholder="新手机号"
            />
            <field v-model="mobilecode" placeholder="验证码">
                <template #button>
                    <Button @click="sendCode" size="small" type="primary">{{buttonText}}</Button>
                </template>
            </field>
        </cell-group>
        <div class="btn">
            <Button @click="bind" type="info" block>确认</Button>
        </div>
        <div class="page-end">@游尚智联 技术支持</div>
    </div>
</template>
<script>
import { Field,CellGroup,Button,Image,Toast} from 'vant';
import avatar from '../../assets/user.png'
import {resUrl} from '../../config/env'
import qs from 'qs'
import localstore from '../../util/localstore'
import {mapMutations} from 'vuex'
let timer;
export default {
    data(){
        return {
            resUrl,
            avatar,
            type:'',
            mobile:'',
            oldmobile:'',
            mobilecode:'',
            buttonText:'发送验证码'
        }
    },
    computed:{
        shop(){
            return this.$store.state.shop;
        },
        token(){
            return 'token=' + this.$store.state.oauth.token;
        }
    },
    components:{Field,CellGroup,Button,VanImage:Image},
    created(){
        this.type = this.$route.query.type;
    },
    methods:{
        ...mapMutations(['setlogin']),
        sendCode(){
            let data = {mobile:this.mobile};
            if(this.type == 'rep'){
                if(!this.oldmobile || this.oldmobile.length < 11){
                    Toast('请输入正确的手机号')
                    return;
                }
                data.oldmobile = this.oldmobile;
            }
            if(!this.mobile || this.mobile.length < 11){
                Toast('请输入正确的手机号')
                return;
            }
            if(timer) return;
            let that = this;
            this.$http({
                method:'post',
                url:'mine/bind/getcode?' + this.token,
                data:qs.stringify(data)
            }).then(function(res){
                let {data} = res;
                if(data.status == 200){
                    Toast('验证码发送成功');
                }else{
                    Toast(data.message)
                }
            })
        },
        bind(){
            let that = this;
            this.axios({
                method:'post',
                url:'mine/bind/bindok?' + this.token,
                data:qs.stringify({mobile:this.mobile,oldmobile:this.oldmobile,code:this.mobilecode})
            }).then(function(res){
                let {data} = res;
                if(data.status == 200){
                    localstore.remove('ld_user');
                    localstore.remove('ld_oauth');
                    that.setlogin({user:data.user,oauth:data.oauth});
                    that.$router.replace('/wode')
                }else{
                    Toast(data.message)
                }
            })
        },
        error(msg){
            Toast(msg)
        }
    }
}
</script>
<style>
.van-cell{
    border:0;
}
.shop-info{
    padding:10px 16px;
    text-align:center;
}
.shop-info .logo{
    width:60px;
    height:60px;
    border-radius:60px;
    overflow:hidden;
}
.shop-info .shop-title{
    margin-top:10px;
    text-align:center;
}
.btn{
    padding:10px 16px;
}
</style>